import type React from 'react'
import {PageNavigation} from 'pepsico-ds'
import type {PageNavigationProps} from 'pepsico-ds'

// Using type instead of interface since we're not adding any properties
type PageNavigationWrapperProps = PageNavigationProps

/**
 * Wrapper component for the Pepsico Design System PageNavigation component
 * This wrapper ensures consistent usage across the application
 */
const PageNavigationWrapper: React.FC<PageNavigationWrapperProps> = props => {
  return <PageNavigation {...props} />
}

export default PageNavigationWrapper
